(function() {    
	const cookie = blue.meth.cookie = {
			del(key) {
					this.set(key, '', '', -1)
			},
			get(key, val = null) {
					const value = document.cookie.match(`(^|;) ?${key}=([^;]*)(;|$)`)
					return value ? value[2] : val
			},
			set(key, val, url = '/', days = 0) {
					const date = new Date
					date.setTime(date.getTime() + 24 * 60 * 60 * 1000 * days)
					document.cookie = `${key}=${val};path=${url};expires=${date.toGMTString()}`
			}
	}
})();